import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";
import { Icon } from "../../icons";
import { COLORS, FONT_FAMILY, TYPOGRAPHY } from "../../constants/color";

const ChecklistCard = ({
  title,
  createdBy,
  createdDate,
  completedCount,
  requestsCount,
  onEdit,
  userRole, // Add userRole prop
}) => {
  // Check if user is admin or superadmin
  const isAdmin = userRole === "ADMIN" || userRole === "SUPERADMIN";
  
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: `1px solid ${COLORS.BORDER}`,
        backgroundColor: COLORS.BACKGROUND,
        transition: "box-shadow 0.2s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
        },
      }}
    >
      <CardContent sx={{ 
        p: 2, 
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:last-child": { pb: 2 } 
      }}>
        {/* ===== HEADER ===== */}
        <Box sx={{ position: "relative", pr: isAdmin ? 4 : 0, flex: 1 }}>
          {/* Title */}
          <Typography
            sx={{
              fontFamily: FONT_FAMILY,
              ...TYPOGRAPHY.H4,
              color: COLORS.PRIMARY,
              wordBreak: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {title}
          </Typography>

          {/* Created by info */}
          <Typography
            sx={{
              fontFamily: FONT_FAMILY,
              ...TYPOGRAPHY.BODY_SMALL,
              color: COLORS.PRIMARY,
              mt: 0.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            Created by {createdBy} on {createdDate}
          </Typography>

          {/* Edit Icon - Only for Admin */}
          {isAdmin && (
            <Box
              onClick={onEdit}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                cursor: "pointer",
                color: COLORS.GREEN_LIGHT,
                "&:hover": { 
                  color: COLORS.SECONDARY,
                  opacity: 0.8 
                },
              }}
            >
              <Icon name="edit" size={16} color="currentColor" />
            </Box>
          )}
        </Box>

        {/* ===== STATS ===== */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "stretch",
          }}
        >
          {/* Completed */}
          <Box sx={{ 
            flex: 1, 
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                ...TYPOGRAPHY.H3,
                color: COLORS.GREEN_LIGHT,
                lineHeight: 1.2,
              }}
            >
              {completedCount}
            </Typography>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                ...TYPOGRAPHY.BODY_STANDARD,
                color: COLORS.PRIMARY,
                mt: 0.5,
              }}
            >
              Completed
            </Typography>
          </Box>

          {/* Divider */}
          <Box
            sx={{
              width: "2px",
              backgroundColor: COLORS.LIGHT_SECONDARY,
              mx: 3,
              alignSelf: "stretch",
            }}
          />

          {/* Requests */}
          <Box sx={{ 
            flex: 1, 
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                ...TYPOGRAPHY.H3,
                color: COLORS.SECONDARY,
                lineHeight: 1.2,
              }}
            >
              {requestsCount}
            </Typography>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                ...TYPOGRAPHY.BODY_STANDARD,
                color: COLORS.PRIMARY,
                mt: 0.5,
              }}
            >
              Requests
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChecklistCard;